<template>
    <div>
        <v-card class="elevation-0">
            <v-toolbar card dense color="transparent">
                <v-toolbar-title><h4>{{$t('lang.notification.title')}}</h4></v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <div id="notify-list" style="max-height: 600px;overflow-y: scroll">
                    <v-list two-line class="pa-0 scroll-y" v-if="items && items.length > 0">
                        <template>
                            <div v-for="(item, index) in items" class="notify" :key="index" @click="handleClick(item)">
                                <label class="user">{{item.senderName}} </label>
                                <label> {{item.title}}</label>
                                <div class="time">{{ item.notifyTime|formatDateTime }}</div>
                            </div>
                            <v-btn block flat class="ma-0" @click="showAllActivities" v-if="count == items.length">
                                Không có thêm thông báo nào
                            </v-btn>
                            <v-progress-linear
                                    indeterminate
                                    color="pink"
                                    v-else-if="count > items.length"
                            ></v-progress-linear>
                        </template>
                    </v-list>
                    <div v-else>
                        <template>
                            <v-subheader>{{$t('lang.notification.notifyEmpty')}}</v-subheader>
                        </template>
                    </div>
                </div>
                <!--
                <v-divider></v-divider>

                                <v-btn block flat class="ma-0" @click="showAllActivities" v-if="count == items.length">
                                    Không có thêm thông báo nào
                                </v-btn>
                -->
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import {router} from "../../../router";
    import axios from "axios";

    export default {
        props: {
            items: {
                type: Array,
                default: () => {
                    return []
                }
            },

            count: {
                type: Number,
                default: () => {
                    return 0
                }
            }
        },
        data() {
            return {
                clickedCard: {}
            };
        },

        mounted() {
            let div = document.getElementById("notify-list");
            console.log(div);
            div.onscroll = (ev) => {
                let div = document.getElementById("notify-list");
                console.log("--- scroll ---");
                console.log(div.offsetHeight + div.scrollTop);
                console.log(div.scrollHeight);
                console.log("--- end scroll ---");
                if (div.offsetHeight + div.scrollTop >= div.scrollHeight) {
                    console.log("--- end ---")
                    this.showAllActivities();
                }
            };

        },

        methods: {
            handleClick(item) {
                console.log(item);
                if (item.objectType == 7) {
                    this.$router.push({path: "/ViewClass/" + item.objectId});
                } else {
                    axios.post(process.env.VUE_APP_API_URL + "/post/getPostByObjectIdAndType?objectId=" + item.objectId + "&objectType=" + item.objectType).then(
                        data => {
                            if (data != null) {
                                //this.$router.go(-1);
                                this.$router.push({path: "/ViewClass/" + data.classId + "/" + item.objectType + "/" + item.objectId + "/" + item.senderId});
                                //window.location.reload();
                            }
                        },
                        error => {

                        }
                    );
                }
            },

            scrollNotify: function () {
                let div = document.getElementById("notify-list");
                //console.log("--- scroll ---");
                console.log(div.innerHeight + div.scrollY);
                console.log(div.offsetHeight);
                console.log("--- end scroll ---");
                if (div.offsetHeight + div.scrollTop >= div.scrollHeight) {
                    console.log("--- end ---")
                    this.showAllActivities();
                }
            },

            showAllActivities() {
                this.$emit("showAllActivity");
            }
        }
    };
</script>
